
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sbca",
      function () {
        return require("private-next-pages/sbca.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sbca"])
      });
    }
  